import React from 'react';
import { Box } from '@mui/material';
import { planVersionInfo } from 'utils/index';

/**
 * A plan's name with its version as a badge.
 *
 * The version is metadata about the plan, not part of what it is called — a
 * customer never sees "Plus V2" — so it reads as an attached marker rather than
 * two words of a title. Matches the badge the plan list and the admin selectors
 * already use.
 */
const PlanLabel = ({ plans, planKey, muted = false }) => {
    const title = plans?.[planKey]?.title || planKey;
    const { version, showVersion } = planVersionInfo({ plans }, planKey);

    if (!showVersion) return title;

    return (
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            {title}
            <Box
                component="span"
                sx={{
                    fontSize: '10px',
                    fontWeight: 700,
                    lineHeight: 1,
                    padding: '3px 5px',
                    borderRadius: '4px',
                    backgroundColor: muted ? '#F3F4F6' : '#EEF2FF',
                    color: muted ? '#6B7280' : '#4338CA',
                    border: `1px solid ${muted ? '#E5E7EB' : '#C7D2FE'}`,
                }}
            >
                {`V${version}`}
            </Box>
        </Box>
    );
};

export default PlanLabel;
